(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function toast(msg) {
    var t = $('#toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    setTimeout(function () { t.classList.remove('show'); }, 2200);
  }

  /* ---------- Gallery ---------- */
  var galMain = $('#galMain');
  var thumbs = $$('#thumbs .thumb');
  var galIndex = 0;

  var galVideo = document.getElementById('galVideo');
  function stopVideo() { if (galVideo) { galVideo.hidden = true; galVideo.innerHTML = ''; } }
  function setImage(i) {
    if (!thumbs.length || !galMain) return;
    galIndex = (i + thumbs.length) % thumbs.length;
    var btn = thumbs[galIndex];
    var type = btn.getAttribute('data-type');
    var full = btn.getAttribute('data-full');
    var video = btn.getAttribute('data-video');
    if (type === 'video' && video && galVideo) {
      galMain.style.display = 'none';
      galVideo.hidden = false;
      galVideo.innerHTML = '<video src="' + video + '" controls playsinline preload="metadata"></video>';
    } else {
      stopVideo();
      galMain.style.display = '';
      if (full) galMain.src = full;
    }
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    btn.classList.add('active');
  }
  thumbs.forEach(function (btn, i) {
    btn.addEventListener('click', function () { setImage(i); });
  });
  var galPrev = $('#galPrev'), galNext = $('#galNext');
  if (galPrev) galPrev.addEventListener('click', function () { setImage(galIndex - 1); });
  if (galNext) galNext.addEventListener('click', function () { setImage(galIndex + 1); });
  if (thumbs.length && thumbs[0].getAttribute('data-type') === 'video') setImage(0);

  /* ---------- Variant swatches ---------- */
  var select = $('#variantSelect');
  var swatches = $$('#swatches .vopt');

  function optionForValue(value) {
    if (!select) return null;
    return Array.prototype.slice.call(select.options).filter(function (o) {
      return o.getAttribute('data-title') === value;
    })[0];
  }

  function setAvailability(available) {
    var status = $('#stockStatus');
    var statusText = $('#stockText');
    var addBtn = $('#buyInstant');
    var stickyBtn = $('#stickyBtn');
    var payWrap = $('#payWrap');
    if (status) status.classList.toggle('sold', !available);
    if (statusText) statusText.textContent = available ? 'In stock, ready to ship' : 'Sold out';
    if (addBtn) {
      addBtn.disabled = !available;
      addBtn.classList.toggle('btn-soldout', !available);
      addBtn.textContent = available ? 'Add to cart' : 'Sold out';
    }
    if (stickyBtn) {
      stickyBtn.disabled = !available;
      stickyBtn.classList.toggle('btn-soldout', !available);
      stickyBtn.textContent = available ? 'Add to Cart' : 'Sold out';
    }
    if (payWrap) payWrap.style.display = available ? '' : 'none';
  }

  function selectVariant(value) {
    var opt = optionForValue(value);
    if (!opt) return;
    select.value = opt.value;
    var price = opt.getAttribute('data-price');
    var available = opt.getAttribute('data-available') !== 'false';
    var nameEl = $('#variantName');
    if (nameEl) nameEl.textContent = value;
    var priceNow = $('#priceNow'); if (priceNow && price) priceNow.textContent = price;
    var stickyPrice = $('#stickyPrice'); if (stickyPrice && price) stickyPrice.textContent = price;
    swatches.forEach(function (s) { s.classList.toggle('active', s.getAttribute('data-value') === value); });
    setAvailability(available);
    // move gallery to a matching image if a thumb alt/src references the value
    var idx = thumbs.findIndex(function (t) {
      var img = t.querySelector('img');
      return img && img.alt && img.alt.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    });
    if (idx > -1) setImage(idx);
  }

  swatches.forEach(function (s) {
    s.addEventListener('click', function () { selectVariant(s.getAttribute('data-value')); });
  });

  /* ---------- "Meet the squad" variant cards ---------- */
  $$('#variantsGrid .vcard').forEach(function (card) {
    var val = card.getAttribute('data-value');
    if (!val) return;
    card.style.cursor = 'pointer';
    card.addEventListener('click', function () {
      selectVariant(val);
      var buy = document.getElementById('buy');
      if (buy) buy.scrollIntoView({ behavior: 'smooth' });
      toast(val + ' selected! 💜');
    });
  });

  /* ---------- Quantity ---------- */
  var qtyVal = $('#qtyValue');
  var qtyInput = $('#qtyInput');
  var qty = 1;
  function setQty(n) {
    qty = Math.max(1, n);
    if (qtyVal) qtyVal.textContent = qty;
    if (qtyInput) qtyInput.value = qty;
  }
  var qtyMinus = $('#qtyMinus'), qtyPlus = $('#qtyPlus');
  if (qtyMinus) qtyMinus.addEventListener('click', function () { setQty(qty - 1); });
  if (qtyPlus) qtyPlus.addEventListener('click', function () { setQty(qty + 1); });

  /* ---------- Sticky bar ---------- */
  var stickyBtn = $('#stickyBtn');
  var form = $('#productForm');
  if (stickyBtn && form) {
    stickyBtn.addEventListener('click', function () {
      var addBtn = $('#buyInstant');
      if (addBtn) addBtn.click();
    });
  }

  var stickyBar = $('#stickyBuy');
  var buyBox = $('.buybox');
  if (stickyBar && buyBox && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        stickyBar.classList.toggle('show', !e.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(buyBox);
  }

  /* ---------- Cart drawer (slide-out sidebar) ---------- */
  var drawer = $('#cartDrawer');
  var overlay = $('#drawerOverlay');

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('show');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('show');
    document.body.style.overflow = '';
  }

  function renderCart(cart) {
    var count = $('#cartCount');
    if (count) count.textContent = cart.item_count;
    var items = $('#cartItems');
    var empty = $('#cartEmpty');
    var foot = $('#drawerFoot');
    var totalEl = $('#cartTotal');
    if (!items) return;

    if (cart.item_count === 0) {
      items.innerHTML = '';
      if (empty) empty.style.display = '';
      if (foot) foot.hidden = true;
      return;
    }
    if (empty) empty.style.display = 'none';
    if (foot) foot.hidden = false;
    if (totalEl) totalEl.textContent = money(cart.total_price);

    items.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image + '" alt="' + (it.product_title || '') + '">' : '';
      return '' +
        '<div class="cart-item" data-key="' + it.key + '">' +
        '<div class="cart-item-img">' + img + '</div>' +
        '<div class="cart-item-info">' +
        '<div class="cart-item-name">' + it.product_title + '</div>' +
        (it.variant_title ? '<div class="cart-item-variant">' + it.variant_title + '</div>' : '') +
        '<div class="cart-item-qty">' +
        '<button type="button" class="ci-minus" data-key="' + it.key + '" aria-label="Decrease">−</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" class="ci-plus" data-key="' + it.key + '" aria-label="Increase">+</button>' +
        '<button type="button" class="ci-remove" data-key="' + it.key + '" aria-label="Remove">Remove</button>' +
        '</div></div>' +
        '<div class="cart-item-price">' + money(it.final_line_price) + '</div>' +
        '</div>';
    }).join('');
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); return cart; });
  }

  // Open drawer from the header cart icon (instead of navigating to /cart)
  var cartOpen = $('#cartOpen');
  if (cartOpen && drawer) {
    cartOpen.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
      fetchCart();
    });
  }
  var cartClose = $('#cartClose');
  if (cartClose) cartClose.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  var checkoutBtn = $('#checkoutBtn');
  if (checkoutBtn) checkoutBtn.addEventListener('click', function () { window.location.href = '/checkout'; });

  // Delegate qty +/- and remove inside the drawer
  var cartItemsEl = $('#cartItems');
  if (cartItemsEl) {
    cartItemsEl.addEventListener('click', function (e) {
      var t = e.target;
      var key = t.getAttribute('data-key');
      if (!key) return;
      var row = t.closest('.cart-item');
      var qtySpan = row ? row.querySelector('.cart-item-qty span') : null;
      var current = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;
      if (t.classList.contains('ci-plus')) changeLine(key, current + 1);
      else if (t.classList.contains('ci-minus')) changeLine(key, Math.max(0, current - 1));
      else if (t.classList.contains('ci-remove')) changeLine(key, 0);
    });
  }

  /* ---------- AJAX add to cart → opens the drawer ---------- */
  if (form) {
    form.addEventListener('submit', function (e) {
      var sel = select ? select.options[select.selectedIndex] : null;
      if (sel && sel.getAttribute('data-available') === 'false') {
        e.preventDefault();
        toast('This size is sold out');
        return;
      }
      if (!window.fetch || !drawer) return; // fall back to normal POST
      e.preventDefault();
      var id = select ? select.value : (form.querySelector('[name="id"]') || {}).value;
      var body = { items: [{ id: id, quantity: qty }] };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        toast('Added to cart 🎉');
        return fetchCart();
      }).then(function () {
        openDrawer();
      }).catch(function () { form.submit(); });
    });
  }

  /* ---------- Live viewers flicker ---------- */
  var viewers = $('#viewersNow');
  if (viewers) {
    setInterval(function () {
      var base = 214, delta = Math.floor(Math.random() * 18) - 9;
      viewers.textContent = Math.max(180, base + delta);
    }, 4000);
  }
})();
